export default {
  columns: {
    strategy: 'Strategie',
    source: 'Sursă',
    async: 'Async',
    content: 'Conținut',
    edit: 'Editați',
    delete: 'Ștergeți',
  },
  buttons: {
    add_script: 'Adăugați script',
  },
};
